import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/accept-invite')({
  // Component is lazy loaded from accept-invite.lazy.tsx
});
